import Alpine from 'alpinejs'
import AlpineFocus from '@alpinejs/focus'

import AlpineGlobals from '../js/alpine/index'

// Register and initialize AlpineJS
window.Alpine = Alpine

Alpine.plugin([AlpineFocus])
AlpineGlobals.register(Alpine)
Alpine.start()

// Hide the Shopify preview bar in development
if (import.meta.env.DEV) {
  window.addEventListener('DOMContentLoaded', () => {
    const css = '#preview-bar-iframe { display: none !important; }';
    const headEl = document.head || document.getElementsByTagName('head')[0];
    const styleEl = document.createElement('style')

    headEl.appendChild(styleEl)

    styleEl.appendChild(document.createTextNode(css))
  })
}
